module.exports = __webpack_public_path__ + "static/media/aristotle.3cb9390c.png";